export default {
    routerName: '消息',
    placeholder: {
        selected: '{0}请选择',
        required: '{0}请输入',
        requiredFullWidthChar: '{0}请输入全角文字',
        requiredHalfWidthChar: '{0}请输入半角英字',
        requiredHalfWidthCharOrNumber: '{0}请输入半角英数字',
        requiredHalfWidthNumber: '{0}请输入半角数字',
        lessThen: '{0}请输入小于{1}的值',
        moreThen: '{0}请输入大于{1}的值',
    },
    error: {
        maxLengthFullWidth: '{0}必须小于{1}字节。(半角文字:1字节, 全角文字:2字节)。',
        minLengthFullWidth: '{0}必须大于{1}字节。(半角文字:1字节, 全角文字:2字节)。',
        betweenLengthFullWidth: '{0}必须在{1}-{2}字节范围内。(半角文字:1字节, 全角文字:2字节)。',
        maxLength: '{0}必须小于{1}文字。',
        minLength: '{0}必须大于{1}文字。',
        equal: '{0}和{1}的内容不一致。',
        range: '{0}的内容必须在{1}-{2}范围内。',
        firstChar: '{0}的开头文字必须是{1}。',
        ban: '{0}不能含有禁止文字。',
        format: '{0}格式不正。',
        minus: '{0}不能是负数。',
        required: '{0}不能为空。',
        selected: '{0}必须选择。',
        requiredFullWidthChar: '{0}必须是全角文字。',
        requiredHalfWidthChar: '{0}必须是半角英字。',
        requiredHalfWidthCharOrNumber: '{0}必须是半角英数字。',
        requiredHalfWidthNumber: '{0}必须是半角数字。',
        lessThen: '{0}必须是小于{1}的值。',
        moreThen: '{0}必须是大于{1}的值。',
    },
    action: {
        articleHistory: '历史文章',
        name: '动作',
        search: '搜索',
        show: '显示',
        hide: '隐藏',
        add: '新增',
        edit: '编辑',
        delete: '删除',
        deleteAll: '批量删除',
        submit: '提交',
        reset: '重置',
        clear: '清空',
        random: '随机',
        changePwd: '密码变更',
        changePic: '图片变更',
        cancel: '取消',
        picSelect: '图片选择',
        upload: '上传',
        download: '下载',
        addSuccess: '添加成功。',
        addFail: '添加失败。',
        updateSuccess: '更新成功。',
        moduleUpdateSuccess: '{0}更新成功。',
        updateFail: '更新失败。',
        moduleUpdateFail: '{0}更新失败。',
    },
    file: {
        name: '文件',
        uploadImg: '上传图片',
        error: {
            format: '文件格式不正确。',
            typeFormat: '文件格式不正确，请上传jpg|png|gif格式的图片。',
            moreThenSize: '超出文件最大限制。',
            maxSize: '文件不能超过2M。',
        },
    },
    page: {
        total: '共',
        paper: '件',
    },
    warn: {
        notSelectedRow: '至少选择一条数据',
    },
};
